import { createNaturalArithmeticTask, randInt, simpleSubtractionExplanation } from "./sharedNaturalArithmetic";

function pickData() {
  for (let i = 0; i < 500; i += 1) {
    const a = randInt(24, 98);
    const b = randInt(11, Math.min(87, a - 1));
    const aTens = Math.floor(a / 10);
    const bTens = Math.floor(b / 10);
    if (aTens > bTens && a % 10 >= b % 10) return { a, b, op: "-", result: a - b };
  }
  return { a: 57, b: 24, op: "-", result: 33 };
}

const mod = createNaturalArithmeticTask({
  type: "NaturalSubTwoDigitNoBorrowTask",
  pickData,
  explain: simpleSubtractionExplanation,
});

export const generateTask = mod.generateTask;
export const renderTask = mod.renderTask;
export const renderInput = mod.renderInput;
export const checkAnswer = mod.checkAnswer;
export const renderAnswer = mod.renderAnswer;
export const renderUserAnswer = mod.renderUserAnswer;
export const renderExplanation = mod.renderExplanation;
